module.exports = __webpack_public_path__ + "static/media/broom.4b95a81d.svg";